import { BASE_URL } from "../constants/constants";


const { io } = require("socket.io-client");

// Configure Socket.IO client in WebSocket-only mode to avoid
// polling session-id issues behind reverse proxies/load balancers.
export const IOSOCKETCLIENT = io(BASE_URL, {
  transports: ['websocket'],
  upgrade: false,
  rememberUpgrade: true,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 10,
  timeout: 20000,
  forceNew: false,
  withCredentials: false,
  autoConnect: true,
});

// Add comprehensive error handling and logging
IOSOCKETCLIENT.on('connect_error', (error) => {
  console.warn('Socket.IO connection error:', error?.message || error);
});

IOSOCKETCLIENT.on('connect', () => {
  const transport = IOSOCKETCLIENT.io.engine.transport.name;
  console.log(`Socket.IO connected successfully via ${transport}`);
});

IOSOCKETCLIENT.on('disconnect', (reason) => {
  // Only log unexpected disconnections
  if (reason !== 'io client disconnect') {
    console.log('Socket.IO disconnected:', reason);
  }
});

export const setIOSocketListeners = (channel, socket_channel, listenerCallBacks) => {
  if (channel) {
      if (IOSOCKETCLIENT.hasListeners(socket_channel)) {
          IOSOCKETCLIENT.off(socket_channel);
      }

      IOSOCKETCLIENT.emit('JOINLEAVEROOM', { action: 'join', channel });


      IOSOCKETCLIENT.on(socket_channel, (data) => {
          console.log('Received data on channel:', data); // Debugging line
          listenerCallBacks(data); // Call the listener callback
      });
  }
}